export default "__VITE_ASSET__9802e347__"